import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import React, { forwardRef, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingRight: 0,
  height: "60px",
  "&:hover": {
    "&>div>svg, &>div>span": {
      color: theme.palette.common.black,
    },
  },
  "&.Mui-selected": {
    color: "#00a8e8",
    backgroundColor: "transparent",
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  display: "flex",
  backgroundColor: "transparent",
  alignItems: "center",
  "&:last-of-type": {
    borderBottom: `1px solid ${theme.palette.primary.light}`,
  },
}));

const ActiveListItemText = styled(ListItemText)(({ theme }) => ({
  "&>span": {
    color: "#00a8e8",
  },
}));

const InactiveListItemText = styled(ListItemText)(({ theme }) => ({}));

interface Props {
  primary: string;
  to: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  indent?: boolean;
  blankPage?: boolean;
  sub?: boolean;
}

export const ListItemLink: React.FC<Props> = ({
  icon,
  sub = false,
  primary,
  to,
  disabled = false,
  indent = true,
  blankPage = false,
}) => {
  const location = useLocation();

  const renderLink = useMemo(
    () =>
      // @ts-ignore
      forwardRef((itemProps, ref) => <Link to={to} ref={ref} {...itemProps} />),
    [to]
  );
  const renderNewPage = useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <Link
          to={to}
          // @ts-ignore
          ref={ref}
          target="_blank"
          rel="noopener noreferrer"
          {...itemProps}
        />
      )),
    [to]
  );

  const isActive = () => {
    if (typeof to !== "string") return false;
    if (location.pathname === "/" && to === "/") return true;
    else if (location.pathname.startsWith("/product") && to === "/")
      return true;
    else if (location.pathname !== "/" && to === "/") return false;
    else if (location.pathname.includes(to)) return true;
    else return false;
  };

  return (
    <StyledPaper
      elevation={0}
      sx={
        isActive()
          ? {
              borderRight: (theme) =>
                `6px solid ${theme.palette.secondary.light}`,
              borderRadius: 0,
            }
          : {}
      }>
      {}
      <StyledListItemButton
        // @ts-ignore
        component={blankPage ? renderNewPage : renderLink}
        selected={isActive()}
        disabled={disabled}
        sx={!sub ? { paddingLeft: "60px" } : { paddingLeft: "92px" }}>
        {icon && (
          <ListItemIcon
            sx={
              isActive()
                ? { color: "#00a8e8", minWidth: "36px" }
                : { minWidth: "36px" }
            }>
            {icon}
          </ListItemIcon>
        )}
        {isActive() ? (
          <ActiveListItemText primary={primary} />
        ) : (
          <InactiveListItemText primary={primary} />
        )}
      </StyledListItemButton>
    </StyledPaper>
  );
};
